export function SectionHeader({eyebrow,title,copy}:{eyebrow:string;title:string;copy?:string}) {return <div className="section-head"><div className="eyebrow">{eyebrow}</div><h2>{title}</h2>{copy&&<p>{copy}</p>}</div>}
export function Arrow(){return <span aria-hidden="true">↗</span>}
